/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_DRAFT_APPLICATIONS = gql`
query Data($input: GetPaymentListInput) {
  getListOfPayment(input: $input) {
    currentPage
    pageSize
    totalCount
    totalPages
    data {
      paymentId
      amount
      formattedAmt
      type
      paidOn
      rrn
      status
      from{
        firstName
          middleName
          email
      }
      application {
        type
        applicationNo
        status
        applicantInfo {
          firstName
          middleName
          lastName
          email
        }
        employerInfo {
          name
          orgId
        }
      }
    }
  }
}
`;
